export default "__VITE_ASSET__Ctto2jZp__"